import React from "react";
import { useTranslation } from "react-i18next";
import "./FloatingPreviewButton.css";

const FloatingPreviewButton = ({ onClick, disabled }) => {
  const { t } = useTranslation();

  return (
    <button
      className="floating-preview-btn"
      onClick={onClick}
      disabled={disabled}
      title={t("preview_book")}
      aria-label={t("preview_book")}
    >
      <span className="floating-preview-label">{t("preview")}</span>
      <i className="fa fa-eye"></i>
    </button>
  );
};

export default FloatingPreviewButton;
